import { FC, PropsWithChildren } from "react";
import styles from "./styles.module.css";

const AppRoot: FC<PropsWithChildren> = (props) => {
  return <div className={styles.appcontentRoot} {...props} />;
};

export default AppRoot;
